module.exports = __webpack_public_path__ + "media/images/icon-back-f481421a54aad973ffa3eca74bcf7ffd.svg";